import React, { useEffect, useState } from "react";

const headers = () => {
  const t = localStorage.getItem("access_token") || localStorage.getItem("token") || "";
  return { "Content-Type": "application/json", Authorization: "Bearer " + t };
};

const ROLES = ["trader", "analyst", "investor"];
const th = { padding: "8px 10px", textAlign: "left", fontSize: 12, color: "var(--text-muted)" };
const td = { padding: "8px 10px", fontSize: 13, color: "var(--text-main)" };
const text = (v) => (v && typeof v === "object" ? (v.Valid ? v.String : "") : v || "");
const pick = (u, a, b) => (u[a] !== undefined ? u[a] : u[b]);

const PartnerMembersTab = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState("");

  const load = () => {
    setLoading(true);
    fetch("/api/partner-admin/users", { headers: headers() })
      .then((r) => r.json())
      .then((d) => setUsers(d.ok && Array.isArray(d.data) ? d.data : []))
      .catch(() => setUsers([]))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const changeRole = (id, role) => {
    fetch("/api/partner-admin/users/" + id + "/role", { method: "PUT", headers: headers(), body: JSON.stringify({ role }) })
      .then((r) => r.json())
      .then((d) => {
        setMsg(d.message || d.error || "Done");
        setTimeout(() => setMsg(""), 4000);
        load();
      });
  };

  return (
    <div>
      <h3 style={{ color: "var(--text-main)", marginTop: 0 }}>Members</h3>
      <p style={{ color: "var(--text-muted)", fontSize: 14 }}>
        Set each member's role. In an "Appointed only" community, trader and analyst roles are assigned here.
        A member must sign in again for a role change to take effect.
      </p>
      {msg && <div style={{ background: "var(--success)", color: "#fff", padding: "8px 16px", borderRadius: 6, marginBottom: 16, display: "inline-block" }}>{msg}</div>}
      {loading ? (
        <div style={{ color: "var(--text-muted)" }}>Loading...</div>
      ) : users.length === 0 ? (
        <div style={{ color: "var(--text-muted)" }}>No members yet.</div>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid var(--border)" }}>
              <th style={th}>Email</th><th style={th}>Name</th><th style={th}>Role</th>
              <th style={th}>Status</th><th style={th}>Verified</th><th style={th}>Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => {
              const role = text(pick(u, "primaryRole", "primary_role")) || text(u.role);
              const verified = pick(u, "emailVerified", "email_verified");
              return (
                <tr key={u.id} style={{ borderBottom: "1px solid var(--border)" }}>
                  <td style={td}>{text(u.email)}</td>
                  <td style={td}>{text(u.name)}</td>
                  <td style={td}>
                    <select value={role} onChange={(e) => changeRole(u.id, e.target.value)}
                      style={{ background: "var(--bg-elevated)", color: "var(--text-main)", border: "1px solid var(--border)", borderRadius: 4, padding: "4px 8px" }}>
                      {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
                      {ROLES.indexOf(role) < 0 && <option value={role}>{role}</option>}
                    </select>
                  </td>
                  <td style={td}>{text(u.status)}</td>
                  <td style={td}>{verified ? "yes" : "no"}</td>
                  <td style={td}>{String(text(pick(u, "createdAt", "created_at"))).slice(0, 10)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PartnerMembersTab;
